import NewCoursesPage from './components/NewCoursesPage/NewCoursesPage';

const CoursesPage = () => {
    return <NewCoursesPage />;

    // return version === 'new' ? <NewCoursesPage /> : <OldCoursesPage />;
};

export default CoursesPage;
